<template>
  <ul class="list-group">
    <marked-item v-for="(row, index) in markedList"
                 :item="row"
                 :key="index"
                 @selected="selectContact"
                 @remove="handleMarkedRemove"
                 :index="index"></marked-item>
    <li
        @click="selectContact(item)"
        class="list-group-item d-flex justify-content-between align-items-center"
        v-for="(item, index) in contactShadowList"
        :key="`marked-${item.uid}`"
    >
      <div class="d-flex justify-content-center">
        <div class="avatar">
          <avatar :channel-id="item.channel_id"></avatar>
        </div>
        <span class="mr-2" @click.stop="switchItemToEditing(item.uid)" v-if="item.isNamed">
          <mdb-icon icon="pen"/>
        </span>
      </div>
      <span class="contact-name" v-if="item.isNamed">
        <span class="name-wrap">
          <span>{{ item.name }}</span>
          <img class="channel-img" :src="item.channel_img" v-if="!!(item.channel_img)">
          <span v-if="!!(item.channel_img)">&nbsp;{{ item.channel_id }}</span>
        </span>
        <span class="grey-text">{{ item.time }}</span>
      </span>
      <span class="contact-name" v-if="!item.isNamed">
        <mdb-input basic v-model="item.name">
          <mdb-btn color="default" size="sm" group slot="append" @click.stop="editName(item)">submit</mdb-btn>
          <mdb-btn color="danger" size="sm" group slot="append" @click.stop="cancel(item)">cancel</mdb-btn>
        </mdb-input>
      </span>
      <span class="d-flex justify-content-center align-items-center">
        <mdb-tooltip v-if="item.unread == 0" trigger="hover" :options="{placement: 'top'}">
          <span slot="tip">Mark as unread</span>
          <span slot="reference" @click.stop="markUnread(item.uid)" title="Mark as unread">
            <mdb-icon icon="envelope"></mdb-icon>
          </span>
        </mdb-tooltip>
        <span v-if="item.unread != 0">
          <mdb-icon icon="comment"></mdb-icon>
        </span>
        <span @click.stop="removeContact(item)">
          <mdb-icon class="del_user" far icon="eye-slash" />
        </span>
      </span>
    </li>
  </ul>
</template>

<script>
import Avatar from "./avatar.vue";
import mdbInput from "mdbvue/src/components/Forms/Input";
import mdbBtn from "mdbvue/src/components/Components/Button";
import mdbTooltip from "mdbvue/src/components/Advanced/Tooltip";
import mdbIcon from "mdbvue/src/components/Content/Fa";
import userService from "../Services/UserService";
import markedItem from "./mark-item.vue";
import bookmarkService from "../Services/BookMark";
import badgeService from "../Services/badgeService";

const mdbBtnExtend = {
  ...mdbBtn,
  methods: {
    handleClick(e) {
      this.wave(e);
      this.$emit('click', e);
    }
  }
}

export default {
  components: {
    'marked-item': markedItem,
    mdbTooltip,
    mdbIcon,
    mdbInput,
    mdbBtn: mdbBtnExtend,
    Avatar,
  },
  props: {
    contactList: {
      type: Array,
      default() {
        return []
      }
    },
    old_contacts: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      markedRawList: [],
      editingItems: [],
      removeItems: [],
    }
  },
  computed: {
    markedIDList() {
      return Object.keys(this.markedRawList).map((row) => {
        return parseInt(row) || 0;
      });
    },
    markedList() {
      return this.contactList.filter((row) => {
        return this.markedIDList.includes(row.uid);
      }).sort((a, b) => {
        if (b.unread != a.unread)  {
          return b.unread - a.unread;
        }
        return b.unix - a.unix;
      });
    },
    contactShadowList() {
      return this.contactList.filter((row) => {
        return !this.markedIDList.includes(row.uid);
      }).map((row) => {
        return {
          ...row,
          isNamed: !this.editingItems.includes(row.uid),
        }
      })
    }
  },

  watch: {
    contactList() {
      this.fetchMarkRawList();
    }
  },

  mounted() {
    this.fetchMarkRawList();
  },

  methods: {
    selectContact(item) {
      if (!item.isNamed) {
        return;
      }
      this.$router.push({
        name: "message",
        params: {uid: item.uid}
      });
    },

    switchItemToEditing(uid) {
      this.editingItems.push(uid);
    },

    editName(item) {
      // console.log(this.old_contacts)
      if (!item.name) {
        return;
      }
      let user = new userService();
      user.user(item.uid, item.name).then(() => {
        const index = this.contactList.findIndex(row => {
          return row.uid == item.uid;
        })
        if (index > -1) {
          this.old_contacts[index].name = item.name;
        }
        this.editingItems = this.editingItems.filter((row) => {
          return row !== item.uid;
        })
      });
    },

    cancel(item) {
      const index = this.contactList.findIndex(row => {
        return row.uid == item.uid;
      })
      if (index > -1) {
        this.contactList[index].name = this.old_contacts[index].name;
      }
      this.editingItems = this.editingItems.filter((row) => {
        return row !== item.uid;
      })
    },

    removeContact(item) {
      if (confirm("Are you sure?")) {
        let user = new userService();
        user.remove(item.uid)
        .then((res) => {
          badgeService.remove(item.uid);
        })
        .catch((err)=>{
          alert(err.msg)
        })
      }
    },

    markUnread(uid) {
      let user = new userService();
      const index = this.contactList.findIndex(row => {
        return row.uid == uid;
      })
      if (index > -1) {
        const target = this.contactList[index];
        if (target) {
          user.mark_as_unread(target.uid);
          badgeService.add(target.uid)
        }
      }
    },

    fetchMarkRawList() {
      this.markedRawList = bookmarkService.pull();
    },

    handleMarkedRemove(e) {
      bookmarkService.remove(e.uid);
      this.fetchMarkRawList();
    }
  }
}
</script>

<style>
  .fa-comment{
    color: #4e7cef;
  }
</style>
